// import "@hotwired/turbo-rails"
import Rails from '@rails/ujs';
Rails.start();

import { start as startTurboLinks } from "turbolinks";
startTurboLinks();

import "@nathanvda/cocoon";

// @TODO: is this supposed to be the same thing as the localtime.cjs file??
import LocalTime from "local-time";
LocalTime.start();

import swal from 'sweetalert2';
window.Swal = swal;
